import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { navigate } from "gatsby";
import { updateAddress, deleteAddress, getAddress, getInfo } from "../../../service/accountService";
import { getCartInfo, updateAddressCart } from "../../../service/cartService";
import "../../../pages/mobile/address.css";
const ListDeliveryMobile = ({ back, setLat, setLong }) => {
    const handleClick = (uri) => {
        navigate(uri);
    }
    let [cartInfoItems, setCartInfoItems] = useState("");
    let [cartAddress, setCartAddress] = useState(null);
    const cartInfo = () => {
        try {
            getCartInfo(window.localStorage.getItem('key')).then((response) => {
                if (response.status === 200) {
                    setCartInfoItems(response['message']);
                    setCartAddress(response['message'][0].shipping?.address);
                    console.log(response['message'][0].shipping?.address);
                    console.log(response["message"]);
                }
            }, []);
        } catch (e) {
            console.log(e);
        }
    }
    const [address, setAddress] = useState([]);
    const getDataAddress = () => {
        getAddress(window.localStorage.getItem('key')).then((response) => {
            if (response.status === 200) {
                setAddress(response['message']);
            }
        });
    }
    const handleDeleteAddress = (id) => {
        console.log(id);
        let param = {
            _id: id
        }
        try {
            if (window.confirm('Bạn có chắc chắn muốn xóa không?.')) {
                deleteAddress(param, window.localStorage.getItem('key')).then((response) => {
                    toast.success(response['message']);
                    getDataAddress();
                });
            }

        } catch (e) { console.log(e) }
    }
    const handleClickDetail = (id) => {
        window.location.href = '/mobile/address-detail.html?' + id;
    }
    const handlePickAddress = (id, lat, lng) => {
        console.log(id);
        let addCart = {
            address: id
        }
        updateAddressCart(addCart, window.localStorage.getItem('key')).then((reponse) => {
            if (reponse["status"] == 200) {
                setLat(lat);
                setLong(lng);
                back();
            } else {
                toast.error(reponse["message"]);
                return;
            }
        });
    }
    useEffect(() => {
        cartInfo();
        getDataAddress();
    }, []);
    return (
        <div className="container1">
            <div className="address mt-2">
                {
                    address ? (
                        address.map((item, i) => {
                            return <div className="col-12 mgt-10" key={i}>
                                <div className="card">
                                    <div className="card-body text_14 font_700">
                                        <input defaultChecked={item._id === cartAddress?._id} className="form-check-input" type="radio" name="checkboxAddress" id={item._id} onClick={() => handlePickAddress(item._id, item.location?.latitude, item.location?.longitude)} />
                                        <div className="context-left">
                                            <span>{item.address + ', ' + (item['ward'] ? item['ward']['name'] + ', ' : '') + (item['district'] ? item['district']['name'] + ', ' : '') + (item['province'] ? item['province']['name'] : '')}</span>
                                            <div className="group flex-nowrap font_500">
                                                <span>{item.name}</span>
                                                <span>{item.phone}</span>
                                            </div>
                                            {
                                                item?.current === true ? (
                                                    <div className="badge badge-custom">Mặc định</div>
                                                ) : (null)
                                            }
                                        </div>
                                        <div id="content1">
                                            <details>
                                                <summary>
                                                    <table>
                                                        <tr>
                                                            <td><img src="/../images/account/three_dots.svg" alt="icon"/></td>
                                                            <td></td>
                                                        </tr>
                                                    </table>
                                                </summary>
                                                <div>
                                                    <a onClick={() => { handleClickDetail(item._id) }}><i title="Chỉnh sửa" className="fa fa-pen-to-square"></i><p>Sửa</p></a>
                                                    {
                                                        item?.current === false || item?._id === cartAddress?._id ? (
                                                            <a onClick={() => handleDeleteAddress(item._id)}><i title="Xóa" className="fa fa-trash-can" ></i><p>Xóa</p></a>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </div>
                                            </details>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    ) : (
                        <div className="col-12 flex-center-col gap_10">
                            <img src="/../images/account/address.svg" alt="icon"/>
                            <span className="text_13 font_400">Bạn chưa có địa chỉ giao hàng</span>
                        </div>
                    )
                }
                <div className="col-12 flex-center">
                    <button className="btn-add-address mgt-10" onClick={() => handleClick('/mobile/address-detail.html')}>THÊM ĐỊA CHỈ GIAO HÀNG</button>
                </div>
            </div>
        </div>
    )
}
export default ListDeliveryMobile;